// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1___98cc9088f71a86cd96d","cls2":"AccountMenu-cls2___2a8bf7eedd86cbff98d AccountMenu-cls1___98cc9088f71a86cd96d"};